import { Head } from '@inertiajs/react'

const TermsOfService = () => {
  return (
    <>
      <Head title="Termos de Uso" />

      <div className="min-h-screen bg-background">
        <div className="max-w-3xl mx-auto px-6 py-12">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-2">
              Termos de Uso
            </h1>
            <p className="text-lg font-semibold text-foreground mb-1">
              StationZero Tecnologias LTDA
            </p>
            <p className="text-muted-foreground">
              Última atualização: {new Date().toLocaleDateString('pt-BR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>

          {/* Content */}
          <div className="space-y-6 text-foreground leading-relaxed">

            <p>
              Estes Termos de Uso ("Termos") constituem um acordo legalmente vinculante entre Você, seja pessoa física ou jurídica ("Usuário" ou "Você"), e a StationZero Tecnologias LTDA, pessoa jurídica de direito privado com sede na Cidade do Rio de Janeiro/RJ, Brasil ("StationZero Tecnologias"), e regulam o acesso e uso da plataforma digital, serviços e funcionalidades disponibilizados em www.stationzero.ai ou por meio de qualquer aplicativo ou canal associado à StationZero Tecnologias ("Plataforma" ou "Serviços").
            </p>

            <p>
              Ao clicar em "Aceitar", "Concordar" ou qualquer termo equivalente (coletivamente denominado "Aceite"), ou ao contratar ou utilizar os Serviços, Você declara que leu, compreendeu e aceita integralmente estes Termos, bem como a Política de Privacidade aplicável. Caso Você seja representante legal e/ou esteja agindo em nome de uma pessoa jurídica, Você também declara, ao conceder o Aceite, que possui poderes para vincular a pessoa jurídica que representa a estes Termos.
            </p>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">1. Objeto e Escopo</h2>

              <p className="mb-4">
                <span className="font-semibold">1.1.</span> Mediante o Aceite, a StationZero Tecnologias concederá ao Usuário o direito de uso de uma (1) licença limitada, revogável, não exclusiva e intransferível para acessar e utilizar, de acordo com o plano contratado, a Plataforma e os serviços de inteligência artificial, automação de mídia, integrações com APIs de terceiros, dashboards de análise, relatórios e demais funcionalidades da Plataforma.
              </p>

              <p className="mb-4">
                <span className="font-semibold">1.2.</span> Os Serviços incluem, sem limitação, a criação e manutenção de agentes de IA personalizados, integração com plataformas de anúncios e dados (ex.: Meta Ads, Google Ads, TikTok Ads), acesso a dashboards de desempenho, créditos mensais conforme o plano, suporte técnico e consultoria especializada, conforme aplicável ao plano selecionado.
              </p>

              <p>
                <span className="font-semibold">1.3.</span> A StationZero Tecnologias reserva-se o direito de modificar, suspender ou descontinuar funcionalidades da Plataforma a qualquer momento, o que será devidamente comunicado ao Usuário, não constituindo tal modificação, por si só, descumprimento contratual.
              </p>
            </div>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">2. Cadastro, Conta e Credenciais</h2>

              <p className="mb-4">
                <span className="font-semibold">2.1.</span> Para contratar ou utilizar os Serviços, o Usuário deverá realizar o cadastro com informações verdadeiras, completas e atualizadas, aceitando que a StationZero Tecnologias poderá verificar ou validar tais dados e, em caso de inconsistências e/ou verificação de informações fraudulentas, inconsistentes e/ou inverídicas, poderá cancelar ou revogar o acesso à Plataforma ou cancelar contas.
              </p>

              <p className="mb-4">
                <span className="font-semibold">2.2.</span> A autoria, confidencialidade e uso das credenciais de acesso são de responsabilidade exclusiva do Usuário. O Usuário será responsável por todas as atividades realizadas por meio de sua conta, ainda que não autorizadas por ele.
              </p>

              <p>
                <span className="font-semibold">2.3.</span> Em caso de suspeita de violação, uso indevido ou acesso não autorizado à conta, o Usuário deverá notificar imediatamente a StationZero Tecnologias. A StationZero Tecnologias poderá suspender ou encerrar contas a seu critério, especialmente em casos de violação destes Termos ou suspeita de fraude.
              </p>
            </div>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">3. Contratação, Preços, Pagamento e Renovação</h2>

              <p className="mb-4">
                <span className="font-semibold">3.1.</span> A contratação dos Serviços será realizada eletronicamente: seleção de um plano, aceite destes Termos via clique ("click-wrap") e confirmação de pagamento conforme as condições disponíveis na Plataforma no momento da contratação.
              </p>

              <p className="mb-2 font-semibold">3.2. Mensalidade.</p>
              <p className="mb-4">
                A remuneração da StationZero Tecnologias será cobrada mensalmente, conforme os valores e formas de pagamento listados na página da Plataforma. Os pagamentos mensais subsequentes serão cobrados no mesmo dia dos meses seguintes a partir da data de vigência deste contrato.
              </p>

              <p className="mb-4">
                <span className="font-semibold">3.2.1.</span> Os valores listados na página da Plataforma incluirão o número de créditos expressamente previstos na referida página. Caso créditos adicionais sejam necessários, será cobrada uma taxa adicional, que variará conforme o plano contratado e cada pacote de créditos adicionais.
              </p>

              <p className="mb-4">
                <span className="font-semibold">3.2.2.</span> O sistema de créditos funcionará como medida de consumo computacional na Plataforma da StationZero Tecnologias, e a quantidade utilizada será renovada/resetada mensalmente, conforme os valores, limites e quantidades estabelecidos nas Seções 3.2 e 3.2.1 acima.
              </p>

              <p className="mb-4">
                <span className="font-semibold">3.2.3.</span> As notas fiscais relativas à remuneração da StationZero Tecnologias serão emitidas conforme os dados de qualificação do Usuário fornecidos durante o cadastro, e cada nota fiscal será emitida pela StationZero Tecnologias considerando as retenções legais aplicáveis pelas quais a StationZero Tecnologias e o Usuário são respectivamente responsáveis.
              </p>

              <p className="mb-4">
                <span className="font-semibold">3.3.</span> Os valores, periodicidade (ex.: mensal, anual), formas de pagamento e demais condições serão indicados na página de planos da Plataforma. A StationZero Tecnologias poderá alterar tais valores ou condições mediante aviso prévio de 15 (quinze) dias, salvo disposição diversa no momento da contratação.
              </p>

              <p className="mb-4">
                <span className="font-semibold">3.4.</span> Salvo disposição em contrário, o contrato entrará em vigor na data de confirmação do pagamento ou ativação da conta, permanecerá vigente pelo período correspondente ao plano escolhido e será automaticamente renovado por períodos iguais até que qualquer das partes manifeste sua intenção de não renovar com pelo menos 30 (trinta) dias de antecedência do término do período vigente.
              </p>

              <p>
                <span className="font-semibold">3.5.</span> A falta de pagamento de qualquer valor devido autorizará a StationZero Tecnologias a suspender imediatamente o acesso aos Serviços, sem prejuízo da cobrança dos valores devidos, encargos de mora e demais penalidades previstas e autorizadas pela legislação aplicável.
              </p>
            </div>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">4. Uso Autorizado e Restrições</h2>

              <p className="mb-4">
                <span className="font-semibold">4.1.</span> O Usuário compromete-se a utilizar os Serviços exclusivamente para fins lícitos, em conformidade com a legislação aplicável e as boas práticas pertinentes à sua área de atuação, sempre observando os limites do plano contratado e destes Termos.
              </p>

              <p className="mb-2">
                <span className="font-semibold">4.2.</span> Sem prejuízo de outras restrições previstas nestes Termos, é expressamente vedado ao Usuário:
              </p>

              <p className="mb-2">
                a) copiar, modificar, adaptar, descompilar, desmontar, realizar engenharia reversa, redistribuir ou criar obras derivadas da Plataforma ou do Software da StationZero Tecnologias;
              </p>
              <p className="mb-2">
                b) utilizar bots, scripts ou outros mecanismos automatizados para acesso não autorizado ou para explorar vulnerabilidades;
              </p>
              <p className="mb-2">
                c) utilizar os Serviços para desenvolver produtos concorrentes ou prestar serviços a terceiros sem autorização;
              </p>
              <p className="mb-2">
                d) utilizar os Serviços para fins que envolvam risco à vida, segurança crítica ou sistemas cujas falhas possam causar danos graves ("Uso de Alto Risco"), em conformidade com padrões análogos aos de grandes licenças de software;
              </p>
              <p>
                e) remover, ocultar ou alterar quaisquer avisos de direitos autorais, marcas registradas ou notificações contidas na Plataforma ou nos materiais da StationZero Tecnologias.
              </p>
            </div>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">5. Propriedade Intelectual</h2>

              <p className="mb-4">
                <span className="font-semibold">5.1.</span> Todo o conteúdo da Plataforma — incluindo, mas não se limitando a, software, código-fonte, algoritmos, interfaces, bancos de dados, documentação, marcas registradas, logotipos e qualquer informação ou elemento de design — é propriedade exclusiva da StationZero Tecnologias ou de seus licenciadores, e é protegido pelas leis brasileiras e internacionais de direitos autorais, marcas e patentes.
              </p>

              <p className="mb-4">
                <span className="font-semibold">5.2.</span> O uso concedido ao Usuário nos termos deste instrumento não confere qualquer direito de propriedade, cessão ou licença dos direitos de propriedade intelectual da StationZero Tecnologias, que continuarão a pertencer à StationZero Tecnologias antes, durante e após a vigência destes Termos.
              </p>

              <p>
                <span className="font-semibold">5.3.</span> Qualquer uso não autorizado dos direitos de propriedade intelectual da StationZero Tecnologias ou de terceiros constituirá infração sujeita às penalidades civis e criminais aplicáveis.
              </p>
            </div>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">6. Confidencialidade</h2>

              <p className="mb-4">
                <span className="font-semibold">6.1.</span> O Usuário reconhece que informações técnicas, comerciais, estratégicas ou de qualquer outra natureza que possam ser fornecidas no âmbito da execução destes Termos e que sejam de caráter "confidencial" ("Informações Confidenciais") deverão ser mantidas em sigilo e não poderão ser divulgadas ou utilizadas para fins diversos dos estabelecidos neste instrumento.
              </p>

              <p className="mb-4">
                <span className="font-semibold">6.2.</span> As obrigações de confidencialidade persistirão por 2 (dois) anos após o encerramento da relação contratual sob estes Termos, salvo disposição legal ou regulatória em contrário.
              </p>

              <p>
                <span className="font-semibold">6.3.</span> Não serão consideradas Informações Confidenciais: (i) informações que estejam em domínio público no momento da divulgação; (ii) informações recebidas de terceiros sem obrigações de confidencialidade; (iii) informações que devam ser divulgadas por ordem judicial ou de autoridade competente, desde que a parte divulgadora notifique previamente a outra parte sempre que possível.
              </p>
            </div>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">7. Tratamento de Dados Pessoais e Privacidade</h2>

              <p className="mb-4">
                <span className="font-semibold">7.1.</span> A StationZero Tecnologias trata dados pessoais em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018) e demais regulamentações aplicáveis no Brasil, bem como quaisquer regulamentações internacionais quando aplicáveis.
              </p>

              <p className="mb-4">
                <span className="font-semibold">7.2.</span> A "Política de Privacidade" disponibilizada na Plataforma é parte integrante destes Termos e define as finalidades, bases legais, categorias de dados, direitos dos titulares, períodos de armazenamento, transferências internacionais, cookies, rastreamento e demais assuntos relacionados.
              </p>

              <p>
                <span className="font-semibold">7.3.</span> Ao contratar ou utilizar os Serviços, o Usuário declara que leu, compreendeu e concorda com os termos da Política de Privacidade.
              </p>
            </div>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">8. Garantias, Isenções e Limitação de Responsabilidade</h2>

              <p className="mb-4">
                <span className="font-semibold">8.1.</span> A StationZero Tecnologias envidará esforços razoáveis para disponibilizar os Serviços de forma segura e contínua, mas não garante que a Plataforma estará livre de interrupções, defeitos, erros ou vulnerabilidades.
              </p>

              <p className="mb-4">
                <span className="font-semibold">8.2.</span> Os Serviços são fornecidos "no estado em que se encontram" e "conforme disponíveis", sem garantias, expressas ou implícitas, incluindo, sem limitação, garantias de comercialização, adequação a uma finalidade específica ou não violação de direitos de terceiros.
              </p>

              <p className="mb-4">
                <span className="font-semibold">8.3.</span> Em nenhuma circunstância a StationZero Tecnologias, seus diretores, funcionários, afiliados ou representantes serão responsáveis por quaisquer danos indiretos, incidentais, especiais, consequenciais ou punitivos, incluindo, sem limitação, lucros cessantes, danos consequenciais, perda de dados, interrupção de negócios e/ou quaisquer outras perdas tangíveis ou intangíveis decorrentes ou relacionadas ao uso ou à impossibilidade de uso da Plataforma.
              </p>

              <p>
                <span className="font-semibold">8.4.</span> Alguns estados ou países não permitem a limitação ou exclusão de danos conforme indicado na Seção 8.3 acima, e o Usuário deverá consultar seus assessores jurídicos e/ou profissionais de confiança para compreender a extensão e validade destes Termos.
              </p>
            </div>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">9. Suporte, Manutenção e Atualizações</h2>

              <p className="mb-4">
                <span className="font-semibold">9.1.</span> A StationZero Tecnologias poderá fornecer suporte técnico e manutenção de acordo com o plano contratado. Níveis de serviço (SLA), canais de suporte e horários serão detalhados na página do plano.
              </p>

              <p className="mb-4">
                <span className="font-semibold">9.2.</span> A StationZero Tecnologias poderá oferecer atualizações, upgrades ou alterações na Plataforma a seu critério, sem necessidade de consentimento adicional do Usuário, desde que compatíveis com o plano contratado.
              </p>

              <p>
                <span className="font-semibold">9.3.</span> O Usuário concorda que a StationZero Tecnologias poderá introduzir atualizações automaticamente para fornecer correções de segurança ou melhorias, mesmo sem notificação adicional.
              </p>
            </div>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">10. Cancelamento, Suspensão e Rescisão</h2>

              <p className="mb-4">
                <span className="font-semibold">10.1.</span> O Usuário poderá cancelar o plano ou os Serviços a qualquer momento seguindo o procedimento disponível na Plataforma, com efeito ao final do período de cobrança vigente.
              </p>

              <p className="mb-4">
                <span className="font-semibold">10.2.</span> A StationZero Tecnologias poderá suspender ou encerrar o acesso aos Serviços, imediatamente ou mediante aviso prévio razoável, em casos como: (i) inadimplência; (ii) violação destes Termos; (iii) uso indevido ou fraudulento da Plataforma; (iv) descontinuação dos Serviços por decisão estratégica, com aviso prévio de 30 (trinta) dias.
              </p>

              <p>
                <span className="font-semibold">10.3.</span> Em caso de rescisão, a StationZero Tecnologias poderá excluir ou tornar inacessíveis os dados do Usuário, após notificação, e não será obrigada a reembolsar quaisquer valores pagos, salvo disposição legal em contrário ou previsão expressa.
              </p>
            </div>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">11. Jurisdição Internacional, Exportação e Conformidade</h2>

              <p className="mb-4">
                <span className="font-semibold">11.1.</span> O Usuário reconhece que os Serviços podem envolver software, hardware ou data centers localizados em diversos países e que seu uso está sujeito a leis de exportação, sanções econômicas e controles tecnológicos. O Usuário compromete-se a cumprir todas as regulamentações de exportação aplicáveis e a não utilizar a Plataforma para fins de "Uso de Alto Risco".
              </p>
              <p>
                <span className="font-semibold">11.2.</span> Caso qualquer disposição destes Termos viole uma lei ou regulamentação aplicável, tal disposição será interpretada de maneira consistente com a lei — se não for possível, será considerada inválida, mas as demais disposições permanecerão em pleno vigor e efeito.
              </p>
            </div>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">12. Disposições Gerais</h2>

              <p className="mb-4">
                <span className="font-semibold">12.1.</span> Estes Termos constituem o acordo integral entre as partes com relação ao objeto aqui tratado, substituindo quaisquer entendimentos ou comunicações anteriores, sejam orais ou escritos.
              </p>

              <p className="mb-4">
                <span className="font-semibold">12.2.</span> A omissão de qualquer das partes em exercer qualquer disposição destes Termos não constituirá renúncia a esse direito.
              </p>

              <p className="mb-4">
                <span className="font-semibold">12.3.</span> O Usuário não poderá ceder ou transferir seus direitos ou obrigações sob este contrato sem o consentimento prévio e por escrito da StationZero Tecnologias. A StationZero Tecnologias poderá ceder seus direitos a qualquer empresa de seu grupo ou em conexão com uma fusão, aquisição ou reorganização societária, desde que o Usuário seja informado.
              </p>

              <p>
                <span className="font-semibold">12.4.</span> Se qualquer disposição destes Termos for considerada inválida ou inexequível, tal invalidade ou inexequibilidade não afetará as demais disposições, que permanecerão em pleno vigor e efeito.
              </p>
            </div>

            <div className="mt-8">
              <h2 className="text-2xl font-bold text-foreground mb-4">13. Lei Aplicável e Foro</h2>

              <p className="mb-4">
                <span className="font-semibold">13.1.</span> Estes Termos serão regidos e interpretados de acordo com as leis da República Federativa do Brasil.
              </p>

              <p>
                <span className="font-semibold">13.2.</span> Fica eleito o foro da Cidade de São Paulo/SP, com exclusão de qualquer outro, por mais privilegiado que seja, para dirimir quaisquer controvérsias decorrentes destes Termos.
              </p>
            </div>

            <div className="mt-12 bg-muted rounded-lg p-6">
              <p className="mb-2 font-semibold text-foreground">StationZero Tecnologias LTDA</p>
              <p className="mb-4">E-mail de contato: contato@stationzero.ai</p>
              <p>© {new Date().getFullYear()} StationZero Tecnologias. Todos os direitos reservados.</p>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default TermsOfService
